var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudsMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "30px",
    height: "30px",
    viewBox: "205.188 -294.319 30 30",
    enableBackground: "new 205.188 -294.319 30 30",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Layer_x3E_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#49494A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M223.88-274.856c-1.192,2.64-4.929,3.499-7.037,0.33c-1.252,0.783-3.043-0.265-3.777-1.604c-0.121-0.206-0.969-0.555-1.155-0.586 c-1.382-0.233-2.659-1.83-2.229-3.649c0.349-1.475,1.89-2.37,3.556-2.083c0.064,0.011,0.134-0.012,0.195-0.018 c0.208-0.469,0.375-0.948,0.622-1.382c1.691-2.974,6.064-3.087,7.888-0.197c0.253,0.4,0.419,0.568,0.952,0.401 c1.665-0.52,3.332,0.459,3.814,2.152c0.042,0.149,0.097,0.294,0.157,0.476c1.318-0.353,2.451-0.115,3.297,0.974 c0.716,0.922,0.799,1.956,0.297,2.986c-0.504,1.034-1.376,1.605-2.546,1.577c-0.509-0.012-0.902,0.089-1.31,0.416 C225.783-274.406,224.835-274.569,223.88-274.856z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudsMap);
export default __webpack_public_path__ + "static/media/clouds-map.319b76e1d9d0669f19a84ffba26bbd13.svg";
export { ForwardRef as ReactComponent };